<template>
  <section id="customer-details" class="ml-2">
    <v-row class="d-flex justify-center" no-gutters>
      <v-col cols="12">
        <page-header
          class="mb-8"
          :breadcrumbs="breadcrumbs"
          :title="customer.name"
        />
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          class="border-bottom-grey"
        >
          <v-tab
            class="px-12 subtitle-2 text-dark-grey font-weight-large"
            active-class="customer-active-tab"
            v-for="({ name, query, elementId }, i) in tabsName"
            :id="elementId"
            v-text="name"
            :key="i"
            @click="onTabChange(query, i)"
          >
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <v-tabs-items v-model="activeTab" class="border-bottom-2 transparent">
          <v-tab-item v-for="itemComponent in tabItems" :key="itemComponent">
            <v-row class="d-flex justify-center" no-gutters>
              <v-col col="12" md="10">
                <keep-alive>
                  <component :is="itemComponent" v-bind="componentProps" />
                </keep-alive>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </section>
</template>
<script>
import { PageHeader } from "@/components/shared";
import { getCustomer } from "@/services";
import { mapActions } from "vuex";
import Accounts from "@/views/Customers/Accounts.vue";
import { AddCustomerForm } from "@/components/forms";
import CustomerSubscription from "./CustomerSubscription.vue";
import CustomerOwners from "./CustomerOwners.vue";
import { TabsNavigatorMixin, TitleMixin } from "@/mixins";
/**
 * Customer Tab View
 */
export default {
  name: "Customer",
  /**
   *   Page title
   */
  title: "Customer",
  /**
   * --------------- Components -------------
   */
  components: {
    Accounts,
    PageHeader,
    CustomerOwners,
    AddCustomerForm,
    CustomerSubscription,
  },
  /**
   * -------------- Mixins -------------
   */
  mixins: [TitleMixin, TabsNavigatorMixin],
  /**
   * --------------Data Attributes ------------
   */
  data() {
    const { snackbarTypes } = this.$appConfig.snackbar;
    return {
      customer: {},
      snackbarTypes,
      tabsName: [
        {
          name: "Customer",
          query: "customer_details",
          elementId: "customer_details",
        },
        { name: "Accounts", query: "accounts", elementId: "accounts" },
        { name: "Owners", query: "owners", elementId: "owners" },
        {
          name: "Subscription",
          query: "subscription",
          elementId: "subscription",
        },
      ],
      tabItems: [
        "AddCustomerForm",
        "Accounts",
        "CustomerOwners",
        "CustomerSubscription",
      ],
      isLoading: false,
    };
  },
  /**
   * -------------Computed properties -----------
   */
  computed: {
    /**
     * Add customer page breadcrumbs
     * @type {Array}
     */
    breadcrumbs() {
      return [
        {
          title: this.$dictionary.app.customers.index.title,
          type: this.$appConfig.breadcrumbs.types.route,
          to: this.$paths.customers,
        },
        {
          title: this.customer?.name,
          type: this.$appConfig.breadcrumbs.types.route,
        },
      ];
    },
    /**
     * Get customer ID from params
     */
    customerId() {
      return this.$route.params?.id;
    },
    /**
     * Get component attrs
     */
    componentProps() {
      const attrs = { customer: this.customer };
      if (this.activeTab == 0) {
        attrs.showSubscription = false;
        attrs.successMessage = this.$dictionary.app.customers.update.successMsg;
      }
      return attrs;
    },
  },
  /**
   * ------------ Methods ----------------
   */
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    /**
     * Get customer details
     */
    async getCustomerDetails() {
      try {
        this.isLoading = true;
        const { data } = await getCustomer(this.customerId);
        this.customer = data || [];
        this.customer.start_date = data?.start_date
          ? data.start_date.split("T")[0]
          : "";
        this.customer.renewal_date = data.renewal_date
          ? data.renewal_date.split("T")[0]
          : "";
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: this.$errorMessage(error),
          type: this.snackbarTypes.error,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  /**
   * ---------- Created Lifecycle ----------
   */
  created() {
    this.getCustomerDetails();
  },
};
</script>
